import PropTypes from "prop-types";
import React from "react";

import Icon from "../../../components/interface/Icon";
import { CSV_IMPORT_COLUMN_TYPE_DO_NOT_IMPORT } from "../../../constants/importExportFile";

const getErrorMessage = (columnType, isError, misMatched) => {
  switch (columnType) {
    case "startDate":
    case "endDate":
    case "latestStartDate":
    case "earliestEndDate":
      return isError ? `No valid dates found` : `${misMatched} invalid dates found`;
    case "color":
      return isError ? "No valid colors found" : `${misMatched} invalid colors found`;
    case "tags":
      return isError ? "No matching tags found" : `${misMatched} unmatched tags`;
    default:
      // relationship items
      return isError ? "No matching items found" : `${misMatched} unmatched items`;
  }
};

const ImportCsvColumnMatch = ({ columnType, matched, misMatched }) => {
  const isError = matched === 0;
  return columnType !== CSV_IMPORT_COLUMN_TYPE_DO_NOT_IMPORT && (matched === 0 || misMatched > 0) ? (
    <div className={`importCsvColumnMatch${isError ? " isError" : ""}`}>
      <Icon className="statusIcon" icon="statusConflict" color={isError ? "statusError" : "statusWarning"} />
      {getErrorMessage(columnType, isError, misMatched)}
    </div>
  ) : null;
};

ImportCsvColumnMatch.propTypes = {
  matched: PropTypes.number.isRequired,
  misMatched: PropTypes.number.isRequired,
  columnType: PropTypes.string.isRequired
};

export default ImportCsvColumnMatch;
